import { AbstractSource } from "../../drawing";
import { IClaioImageSource } from "../../../domain/claio";
import { ImageSourceKinds } from "../../../domain/document/ImageSourceKinds";
import { Size } from "../../../domain/drawing";

export abstract class AbstractClaioImageSource extends AbstractSource implements IClaioImageSource {
  constructor(
    getToken: () => string,
    public patientId: string,
    public claioImageKey: string,
    public imageGuid: string,
    protected _imageSourceKind: ImageSourceKinds,
    public isMovie: boolean,
    public isLeft: boolean,
    public isRight: boolean,
    public isSecret: boolean,
    public departmentId: string,
    public isVisibleLayer: boolean,
    public imageDate: Date,
    public imageKind: string,
    ) {
    super(getToken);
  }

  get imageSourceKind(): ImageSourceKinds {
    return this._imageSourceKind;
  }

  set imageSourceKind(kind: ImageSourceKinds) {
    if (kind === ImageSourceKinds.None) {
      this.patientId = null;
      this.claioImageKey = null;
      this.isMovie = false;
      this.isLeft = false;
      this.isRight = false;
      this.isSecret = false;
      this.departmentId = null;
    }
    this._imageSourceKind = kind;
  }

  protected getSource(): string {
    if (!this.imageGuid) { return null; }
    const url = "/api/document/temporary/image/" + this.imageGuid + "?token=" + this.token;
    console.debug("[claio temporary image source] " + url);
    return url;
  }

  public getResizedOriginalSource(size: Size): string {
    return this.originalSource
      ? this.originalSource + "&width=" + size.width  + "&height=" + size.height
      : this.originalSource;
  }

  public abstract get thumbnailSource(): string;

  public abstract get originalSource(): string;

  public abstract clone(): IClaioImageSource;
}
